<template>
  <div>
    <el-button type="primary" size="small" @click="categoryDialog()">
      添加
    </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column label="名称" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="categoryDialog(row)">
              <div>{{ row.name }}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="图标" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>
        <el-table-column label="新版图标" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <img :src="row.img_url_v2" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="排序" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="updateCategorySort(row.id)"
            >
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="商品" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="categoryProductListDialog(row.id)">
              <div>查看</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="mini"
              @click="
                row.status == 1
                  ? updateCategoryStatus(row.id, 0)
                  : updateCategoryStatus(row.id, 1)
              "
            >
              <div>{{ row.status == 1 ? "下架" : "发布" }}</div>
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="addProductDialog(row.id)"
            >添加商品</el-button>

            <el-button
              type="danger"
              size="small"
              @click="deleteCategory(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <!-- 添加或修改分类 -->
    <el-dialog
      title="分类"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeCategoryDialog"
      width="50%"
    >
      <el-form :model="category" label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称">
          <el-col :span="20">
            <el-input
              v-model="category.name"
              maxlength="10"
              show-word-limit
              placeholder="请输入分类名称"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="图标">
          <el-upload
            class="avatar-uploader"
            :action="ossAction"
            :show-file-list="false"
            :http-request="uploadOSSRequest"
            :before-upload="beforeImageUpload"
          >
            <img
              v-if="category.img_url"
              :src="category.img_url"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="新版图标">
          <el-upload
              class="avatar-uploader"
              :action="ossAction"
              :show-file-list="false"
              :http-request="uploadOSSRequestV2"
              :before-upload="beforeImageUpload"
          >
            <img
                v-if="category.img_url_v2"
                :src="category.img_url_v2"
                class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="closeCategoryDialog()"
            >取 消</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="createUpdateCategory()"
            :loading="updateLoading"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 分类添加商品 -->
    <el-dialog
      title="选择商品"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        ref="multipleTable"
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
      <div style="margin-top: 20px">
        <el-button @click="categoryAddProduct()"
          >确定</el-button
        >
        <el-button @click="toggleSelection()">取消选择</el-button>
      </div>
    </el-dialog>

    <!-- 分类商品列表 -->
    <el-dialog
      title="分类商品列表"
      :visible.sync="categoryProductList.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="closeCategoryProductDialog"
      width="80%"
    >

      <!--列表-->
      <el-table
        border
        :data="categoryProductList.result.data"
        highlight-current-row
        v-loading="categoryProductList.listLoading1"
        style="..."
      >
        <el-table-column prop="product_id" label="ID" align="center" min-width="6%"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          min-width="20%"
        ></el-table-column>
        <el-table-column label="图片" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>
        <el-table-column label="排序" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="updateCategoryProductSort(row.id)"
            >
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              size="mini"
              @click="categoryDeleteProduct(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="categoryProductListDialog(categoryProductList.query.id)"
        :current-page.sync="categoryProductList.query.page"
        :page-size="categoryProductList.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="categoryProductList.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

import { flashSaleProductScreen } from "@/api/promotion";

import {
  categoryList,
  createUpdateCategory,
  deleteCategory,
  updateCategorySort,
  updateCategoryStatus,
  categoryProductList,
  categoryAddProduct,
  categoryDeleteProduct,
  updateCategoryProductSort
} from "@/api/mall";

export default {
  data: function () {
    return {
      ossAction: "",
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      updateLoading: false,
      query: {
        page: 1,
        limit: 20,
        title: "",
      },
      category: {
        id: 0,
        name: "",
        img_url: "",
        img_url_v2: "",
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      categoryProductList: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          limit: 3,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      addProduct: {
          id: 0,
          productIds: []
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    categoryProductListDialog(id) {
        this.categoryProductList.chooseOrgVisible = true;
        this.categoryProductList.query.id = id;
        categoryProductList(this.categoryProductList.query).then((response) => {
            this.categoryProductList.result.data = response.data.list;
            this.categoryProductList.result.total = response.data.total;
            this.categoryProductList.listLoading1 = false;
        });
    },
    updateCategoryProductSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {console.log(value);
          updateCategoryProductSort({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
              this.categoryProductList.chooseOrgVisible = true;
            categoryProductList(this.categoryProductList.query).then((response) => {
                this.categoryProductList.result.data = response.data.list;
                this.categoryProductList.result.total = response.data.total;
                this.categoryProductList.listLoading1 = false;
            });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    closeCategoryProductDialog() {
      this.categoryProductList.chooseOrgVisible = false;
      this.categoryProductList = {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          limit: 10,
        },
        result: {
          total: 0,
          data: [],
        },
      };
    },
    categoryDeleteProduct(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        categoryDeleteProduct({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.categoryProductList.chooseOrgVisible = true;
            categoryProductList(this.categoryProductList.query).then((response) => {
                this.categoryProductList.result.data = response.data.list;
                this.categoryProductList.result.total = response.data.total;
                this.categoryProductList.listLoading1 = false;
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    addProductDialog(id) {
        this.addProduct.id = id;
        this.addProduct.productIds = [];
        this.search.chooseOrgVisible = true;
        this.searchData();
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.search = "";
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
      this.addProduct.id = 0;
        this.addProduct.productIds = [];
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      flashSaleProductScreen(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    handleSelectionChange(rows) {
        this.addProduct.productIds = [];
        rows.forEach(row => {
            this.addProduct.productIds.push(row.id);
        });
    },
    categoryAddProduct() {
        categoryAddProduct(this.addProduct)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.addEditFormOnClose();
            this.getList();
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.category.img_url = fileUrl;
        });
      });
    },
    uploadOSSRequestV2(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.category.img_url_v2 = fileUrl;
        });
      });
    },
    categoryDialog(row = {}) {
      this.dialogVisible = true;
      this.category.id = row.id;
      this.category.name = row.name;
      this.category.img_url = row.img_url;
      this.category.img_url_v2 = row.img_url_v2;
    },
    closeCategoryDialog() {
      this.dialogVisible = false;
      this.category.id = 0;
      this.category.name = "";
      this.category.img_url = "";
      this.category.img_url_v2 = "";
    },
    createUpdateCategory() {
      this.updateLoading = true;
      createUpdateCategory(this.category)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.updateLoading = false;
            this.closeCategoryDialog();
            this.getList();
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    getList() {
      this.loading = true;
      categoryList().then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateCategorySort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          updateCategorySort({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    updateCategoryStatus(id, status) {

      if(status == 1){
        this.$confirm("确认上架分类，上架后将会在前台展示?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          updateCategoryStatus({
            id: id,
            status: status,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        });
      }else{
        updateCategoryStatus({
          id: id,
          status: status,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      }


    },

    deleteCategory(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteCategory({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>